import { ArrowRight } from 'lucide-react'
import { BRAND } from '@/constants/brand'
import type { RfidDocumentRow } from '@/services/rfid.service'
import { getDocumentPlant } from '@/utils/document'
import { cn } from '@/utils/cn'

export type DocumentSummaryChipProps = {
  document: RfidDocumentRow
  customerNumber?: string
  className?: string
}

export function DocumentSummaryChip({
  document,
  customerNumber,
  className,
}: DocumentSummaryChipProps) {
  const plant = getDocumentPlant(document)
  const custNo =
    customerNumber ??
    String(document.Receiver ?? document.Customer ?? document.ReceiverCode ?? '')
  const postingDate = document.PostingDate ? String(document.PostingDate) : null
  const hasFlow = Boolean(plant || custNo)

  return (
    <div className={cn('rfid-doc-chip rfid-doc-chip--wide', className)}>
      <div className="rfid-doc-chip__main">
        <div className="rfid-doc-chip__no truncate">
          #{String(document.DocumentNo ?? '—')}
        </div>
        <div className="rfid-doc-chip__meta line-clamp-2">
          {String(document.CustName ?? '—')}
        </div>
      </div>

      {postingDate || hasFlow ? (
        <div className="rfid-doc-chip__side">
          {postingDate ? (
            <span className="rfid-doc-chip__date">{postingDate}</span>
          ) : null}
          {hasFlow ? (
            <div className="rfid-doc-chip__flow">
              {plant ? <span className="rfid-flow-tag">Plant {plant}</span> : null}
              {plant && custNo ? (
                <ArrowRight size={16} color={BRAND} strokeWidth={2.5} />
              ) : null}
              {custNo ? <span className="rfid-flow-tag">{custNo}</span> : null}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
